import { Button, Dialog } from '../../../components/ui';
import { useLoi } from '../../../hooks/useLoi';
import { useT } from '../../../i18n';
import { LoiTrongHop } from '../../tenant/components/phan-form';
import type { UserProfile } from '../types';

/**
 * Hộp xác nhận khoá tài khoản.
 *
 * Tiêu đề đặt câu hỏi, thân nói hậu quả, nút nhắc lại đúng việc sắp xảy ra.
 * Lỗi (`409` — trạng thái vừa bị đổi, hay tự khoá mình) hiện **trong** hộp
 * bằng câu của server, hộp không đóng.
 */
export function HopKhoaNguoiDung({
  open,
  nguoi,
  dangChay,
  loi,
  onClose,
  onXacNhan,
}: {
  open: boolean;
  /** Giữ nguyên khi hộp đang đóng, để tiêu đề không nháy trống lúc mờ dần. */
  nguoi: UserProfile | null;
  dangChay: boolean;
  loi: unknown;
  onClose: () => void;
  onXacNhan: (nguoi: UserProfile) => void;
}) {
  const { t } = useT();
  const dichLoi = useLoi();
  const ten = nguoi?.display_name ?? '';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t('nguoiDung.xnKhoaTieuDe', { ten })}
      width={480}
      destroyOnHidden
      footer={
        <div className="flex flex-wrap justify-end gap-3">
          <Button variant="outline" size="md" onClick={onClose}>
            {t('chung.huy')}
          </Button>
          <Button
            variant="destructive"
            size="md"
            loading={dangChay}
            onClick={() => nguoi && onXacNhan(nguoi)}
          >
            {t('nguoiDung.khoaTaiKhoan')}
          </Button>
        </div>
      }
    >
      <div className="space-y-3 pt-2">
        <p className="text-sm leading-relaxed text-content-secondary">
          {t(nguoi?.status === 'INVITED' ? 'nguoiDung.xnKhoaThanDaMoi' : 'nguoiDung.xnKhoaThan')}
        </p>
        {Boolean(loi) && <LoiTrongHop>{dichLoi(loi)}</LoiTrongHop>}
      </div>
    </Dialog>
  );
}
